const MILLISECONDS_PER_DAY = 86_400_000
const SAO_PAULO_TIME_ZONE = 'America/Sao_Paulo'

export const RENEWAL_WINDOW_DAYS = 1

const saoPauloDateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: SAO_PAULO_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
})

const startOfSaoPauloDay = (date: Date): number => {
  const values = Object.fromEntries(
    saoPauloDateFormatter
      .formatToParts(date)
      .map(({ type, value }) => [type, value])
  )
  return Date.UTC(
    Number(values.year),
    Number(values.month) - 1,
    Number(values.day)
  )
}

export const calendarDaysUntilDue = (
  dueAt?: string | null,
  now: Date = new Date()
): number | null => {
  if (!dueAt) return null
  const due = new Date(dueAt)
  if (Number.isNaN(due.getTime())) return null
  return Math.round(
    (startOfSaoPauloDay(due) - startOfSaoPauloDay(now)) / MILLISECONDS_PER_DAY
  )
}

export const isRenewalWindowOpen = (
  dueAt?: string | null,
  now: Date = new Date()
): boolean => {
  const daysUntilDue = calendarDaysUntilDue(dueAt, now)
  return daysUntilDue === null || daysUntilDue <= RENEWAL_WINDOW_DAYS
}

export const renewalWindowOpeningDay = (
  dueAt?: string | null,
  locale = 'pt-BR'
): string | null => {
  if (!dueAt) return null
  const due = new Date(dueAt)
  if (Number.isNaN(due.getTime())) return null
  const openingDayInSaoPaulo = new Date(
    startOfSaoPauloDay(due) - RENEWAL_WINDOW_DAYS * MILLISECONDS_PER_DAY
  )
  return new Intl.DateTimeFormat(locale, {
    timeZone: 'UTC',
    day: 'numeric',
    month: 'long'
  }).format(openingDayInSaoPaulo)
}
